module.exports = __webpack_public_path__ + "static/media/logo2jpg.f2b9d2ca.jp2";